export default "__VITE_ASSET__u6q5u6hE__"